export const ENDPOINTS = {
  orders: {
    products: { method: "GET", uri: "/api/orders/products" },
    create: { method: "POST", uri: "/api/orders" },
    capture: { method: "POST", uri: "/api/orders/capture" },
    show: { method: "GET", uri: "/api/orders/:order_id" },
    add_to_cart: { method: "POST", uri: "/api/orders/add_to_cart" },
    list: { method: "GET", uri: "/api/orders" }
  },
  categories: {
    index: { method: "GET", uri: "/api/products/categories" }
  },
  // Bala Add - final_files
  final_files: {
    index: { method: "GET", uri: "api/final_files" }
  },
  batch_enhance: {
    index: { method: "POST", uri: "api/batch_enhance" },
    list: { method: "GET", uri: "api/batch_enhance" }
  },
  imgcredits: {
    index: { method: "GET", uri: "/api/imgcredits" },
    update: { method: "POST", uri: "/api/imgcredits" }
  },
  gemini: {
    index: { method: "POST", uri: "/api/gemini" }
  },
  subid: {
    index: { method: "GET", uri: "/api/subid" }
  },
  files: {
    index: { method: "GET", uri: "api/files" },
    delete: { method: "DELETE", uri: "api/files/:file_path" },
    get: { method: "GET", uri: "api/files/size" }
  },
  user_imgcredits: {
    create: { method: "POST", uri: "/api/user_imgcredits" },
    capture: { method: "POST", uri: "/api/user_imgcredits/capture" },
    show: { method: "GET", uri: "/api/user_imgcredits/:user_imgcredit_id" },
    update: { method: "PUT", uri: "/api/user_imgcredits/:user_imgcredit_id" },
    // add_to_cart: { method: "POST", uri: "/api/orders/add_to_cart" },
    list: { method: "GET", uri: "/api/user_imgcredits" }
  },
  user_storages: {
    create: { method: "POST", uri: "/api/user_storages" },
    capture: { method: "POST", uri: "/api/user_storages/capture" },
    show: { method: "GET", uri: "/api/user_storages/:user_storage_id" },
    update: { method: "PUT", uri: "/api/user_storages/:user_storage_id" },
    // add_to_cart: { method: "POST", uri: "/api/orders/add_to_cart" },
    list: { method: "GET", uri: "/api/user_storages" },
    update_defaults: {
      method: "PUT",
      uri: "/api/user_storages/update_defaults"
    },
    get_defaults: { method: "GET", uri: "/api/user_storages/get_defaults" }
  },
  user_subscriptions: {
    create: { method: "POST", uri: "/api/user_subscriptions" },
    capture: { method: "POST", uri: "/api/user_subscriptions/capture" },
    show: {
      method: "GET",
      uri: "/api/user_subscriptions/:user_subscription_id"
    },
    update: {
      method: "PUT",
      uri: "/api/user_subscriptions/:user_subscription_id"
    },
    // add_to_cart: { method: "POST", uri: "/api/orders/add_to_cart" },
    list: { method: "GET", uri: "/api/user_subscriptions" },
    update_defaults: {
      method: "PUT",
      uri: "/api/user_subscriptions/update_defaults"
    },
    get_defaults: { method: "GET", uri: "/api/user_subscriptions/get_defaults" }
  }
};
